import { Dayjs } from 'dayjs';
import { ThunkApiType } from 'types/storeTypes';
import { formatDayjsForBE } from 'utils/utils';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

export const searchMemberThunk = async (
	props: {
		values: { [key: string]: string | number | Dayjs | null };
		carrierCode: string;
		externalClientId: string;
	},
	thunkAPI: ThunkApiType,
) => {
	const {
		profile: { providerId },
	} = thunkAPI.getState().user;
	const getSearchMemberURL = `/members/carriers/${props.carrierCode}/clients/${props.externalClientId}`;
	const newProps = {
		...props.values,
		providerId,
		dateOfService: formatDayjsForBE(props.values.dateOfService as Dayjs | null),
	};

	try {
		const response = await authFetch.post(getSearchMemberURL, newProps);
		return {
			...response.data,
			inputProps: newProps,
		};
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
